import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from "@mui/icons-material/Done";
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface GeoProps {
  open: boolean;
  handleClose: () => void;
}

function CreateGeoModal({ open, handleClose }: GeoProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const [territoryDetails, setTerritoryDetails] = useState([]);
  const [geoName, setGeoName] = useState(null);
  const [territoryUID, setTerritoryUID] = useState("");
  const [timeZone, setTimeZone] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      MetaEntitiesEndPointLogic.getTerritory(
        setTerritoryDetails,
        oauthTokenHeader
      );
    }
  }, [open, oauthTokenHeader]);

  const CreateGeoData = async () => {
    const data = {
      geo_name: geoName,
      territory_shared_uid: territoryUID,
      timezone: timeZone,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.createMetaGeo(oauthTokenHeader, data);
      } else {
        throw new Error("User doesn't have permissions to create Geo");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaGeoDuplicate(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      setGeoName(null);
      setTerritoryUID("");
      setTimeZone(null);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaGeoDuplicate(
        oauthTokenHeader,
        dispatch
      );
    }
  };

  const handleCancel = () => {
    handleClose();
    setGeoName(null);
    setTerritoryUID("");
    setTimeZone(null);
  };

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
          >
            <Paper sx={{ padding: "16px 24px 20px 24px" }}>
              <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
                Create New Geo
              </DialogTitle>
              <Typography sx={{ mb: 1 }}>Details</Typography>
              <Grid container mt={0} columnSpacing={3}>
                <Grid item xs={6}>
                  <TextField
                    value={geoName}
                    onChange={(e: any) => setGeoName(e.target.value)}
                    id="outlined-multiline-flexible"
                    label="Geo Name *" // Set your label here
                    placeholder="Enter Geo Name" // Set your placeholder here
                    color="secondary"
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={territoryDetails}
                    getOptionLabel={(option: any) => option?.territory_name}
                    onChange={(_, newValue) =>
                      setTerritoryUID(newValue?.shared_uid)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Source"
                        placeholder="Choose Associated Territory Name."
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                        color="secondary"
                        required
                      />
                    )}
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sx={{ mt: 2 }}>
                  <TextField
                    value={timeZone}
                    onChange={(e: any) => setTimeZone(e.target.value)}
                    id="outlined-multiline-flexible"
                    label="Time Zone *" // Set your label here
                    placeholder="Enter Time Zone" // Set your placeholder here
                    color="secondary"
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Typography
                sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
              >
                All fields are mandatory.
              </Typography>

              <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
                <Button color="secondary" onClick={handleCancel} sx={{ mr: 1 }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={!geoName || !territoryUID || !timeZone}
                  onClick={CreateGeoData}
                  data-tracker="237"
                >
                  Create <DoneIcon sx={{ ml: 1 }} />
                </Button>
              </Stack>
            </Paper>
          </Dialog>
        </>
      )}
    </>
  );
}

export default CreateGeoModal;
